// extracted by mini-css-extract-plugin
export default {"Cimgbox":"style_Cimgbox__8hwNU","Carousel":"style_Carousel__g8M41"};